import { em } from 'polished'
import styled, { css } from 'styled-components'

import Icon from 'components/Icon'
import LinkInlineArrowLong from 'components/LinkInlineArrowLong'

export const Item = styled.div`
  display: flex;
  align-items: center;
  width: 130%;
  cursor: pointer;
  z-index: 1;
  position: relative;
  padding: ${em(15)} 0 ${em(15)} ${em(70)};

  ${p => p.theme.mq.upLg} {
    width: 110%;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      ${Description} {
        opacity: 1;
      }

      ${LinkInlineArrowLongStyled} {
        .results-list-item__arrow {
          opacity: 1;
          transform: translateX(${em(5)});
        }
      }
    `}

  &:not(:last-child):before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0px;
    height: 1px;
    background: ${p => p.separatorColor};
    width: calc(100% - ${em(70)});
  }
`

export const IconWrapper = styled.div`
  position: absolute;
  left: 0;
  width: ${em(70)};
  flex-shrink: 0;
  padding-right: ${em(20)};
`

export const IconStyled = styled(Icon)`
  width: ${em(45)};
  height: ${em(45)};

  ${({ id }) =>
    id === 'color_biome' &&
    css`
      width: ${em(54)};
      height: ${em(54)};
    `}
`

export const LinkInlineArrowLongStyled = styled(LinkInlineArrowLong)`
  .results-list-item__arrow {
    position: relative;
    opacity: 0;
    transform: translateX(em(-10));
    transition-property: transform, opacity;
    transition-duration: ${p => p.theme.animation.timeBtns};
    transition-timing-function: ${p => p.theme.animation.cubicBezier};
  }
`

export const Description = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  opacity: ${p => p.theme.blocks.blockMutedOpacity};
  transition: opacity ${p => p.theme.animation.timeBtns}
    ${p => p.theme.animation.cubicBezier};

  ${p => p.theme.mq.hover} {
    &:hover {
      opacity: 1;

      ${LinkInlineArrowLongStyled} {
        .results-list-item__arrow {
          opacity: 1;
          transform: translateX(${em(5)});
        }
      }
    }
  }
`
